import { DateTime, IANAZone } from "luxon";

export const toCompanyScheduleInstant = (wallTime: string, zone: string): string | null => {
  if (!IANAZone.isValidZone(zone) || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(wallTime)) return null;
  const dateTime = DateTime.fromISO(wallTime, { zone });
  // Reject skipped spring hours and repeated fall hours rather than silently moving or choosing an offset.
  if (!dateTime.isValid || dateTime.toFormat("yyyy-MM-dd'T'HH:mm") !== wallTime || dateTime.getPossibleOffsets().length !== 1) return null;
  return dateTime.toUTC().toISO();
};
